module.exports = __webpack_public_path__ + "img/SCB.ebe9af52.png";